// @flow
import { connect } from 'react-redux';
import BonusDetails from './BonusDetails';
import { isLoadingSelector } from '../../../../../modules/LoadingStatus/reducer';
import {
  godfatherValidityErrorSelector,
  referralPromotionBonusSelector,
  shouldBenefitFromActivationBonusSelector,
  shouldShowGodfatherSelector,
} from '../../../../../modules/SignUp/Bonus';
import { activationBonusAmountSelector, isDiscountSelector } from '../../../../../modules/Bonuses';
import {
  isActivationNotFirstSubscriptionSelector,
  promotionCodeSelector,
} from '../../../../../modules/SignUp/Bonus/reducer';
import { currentSubscriptionSelector } from '../../../../../modules/Dashboard';
import { newOfferPriceSelector } from '../../../../../modules/NewOffer/selectors';

const mapStateToProps = state => ({
  referralPromotion: referralPromotionBonusSelector(state),
  isReferralPromotionDiscount: isDiscountSelector(state),
  price: newOfferPriceSelector(state),
  shouldShowGodfather: shouldShowGodfatherSelector(state),
  activationBonusAmount: activationBonusAmountSelector(state),
  isVerifyingBonuses: isLoadingSelector(state, 'verifyBonuses'),
  godfatherValidityError: godfatherValidityErrorSelector(state),
  shouldBenefitFromActivationBonus: shouldBenefitFromActivationBonusSelector(state),
  promotionCode: promotionCodeSelector(state),
  subscriptions: currentSubscriptionSelector(state),
  isNotFirstSubscription: isActivationNotFirstSubscriptionSelector(state),
});

export default connect(mapStateToProps)(BonusDetails);
